import axios from "axios";
import Cookies from "universal-cookie";
import { config, TOKEN } from "../config";

const cookies = new Cookies();

export const clearAuth = () => {
  cookies.remove(TOKEN, { path: "/" });
  cookies.remove("_am_role", { path: "/" });
  cookies.remove("_am_name", { path: "/" });
};

// Add a response interceptor to handle 401, and 403 status codes for automatic logout
const handleResponseError = (error) => {
  if (error.response) {
    const status = error.response.status;
    if (status === 401 || status === 403) {
      clearAuth();
      if (
        typeof window !== "undefined" &&
        window.location.pathname !== "/login"
      ) {
        window.location.href = "/login";
      }
    }
  }
  return Promise.reject(error);
};

// Request interceptor to include the token automatically if present
const handleRequest = (reqConfig) => {
  const token = cookies.get(TOKEN);
  if (token && !reqConfig.headers?.Authorization) {
    reqConfig.headers = {
      ...reqConfig.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return reqConfig;
};

// Configure interceptors on default global axios instance
axios.interceptors.request.use(handleRequest, (error) => Promise.reject(error));
axios.interceptors.response.use((response) => response, handleResponseError);

// Create custom instance
const axiosInstance = axios.create({
  baseURL: config.apiurl,
});

axiosInstance.interceptors.request.use(handleRequest, (error) =>
  Promise.reject(error),
);
axiosInstance.interceptors.response.use(
  (response) => response,
  handleResponseError,
);

export const axiosPrivate = axios.create({
  baseURL: config.apiurl,
  headers: { "Content-Type": "application/json" },
});

axiosPrivate.interceptors.request.use(handleRequest, (error) =>
  Promise.reject(error),
);
axiosPrivate.interceptors.response.use(
  (response) => response,
  handleResponseError,
);

export default axiosInstance;
